module.exports = __webpack_public_path__ + "static/media/hall-void.8220b4c2.svg";